/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.leave-requests.request-reasons'},
});

const RequestReasonsItem = () => (
  <RouteLinkItem
    route="midas/settings/leave-requests/leave-request-reasons"
    title={messages.title}
  />
);

export default RequestReasonsItem;
